import { render, staticRenderFns } from "./Prevention.vue?vue&type=template&id=02e22af9&scoped=true&"
import script from "./Prevention.vue?vue&type=script&lang=js&"
export * from "./Prevention.vue?vue&type=script&lang=js&"
import style0 from "./Prevention.vue?vue&type=style&index=0&id=02e22af9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e22af9",
  null
  
)

export default component.exports